var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "video-share",
      attrs: { "data-grm-comp": "RoomCallScreenShare" },
      on: {
        dblclick: (e) => {
          if (!e.shiftKey) return
          _vm.openSecondWindow()
        },
      },
    },
    [
      _c("div", { staticClass: "share-title" }, [
        _c("span", [
          _vm._v(
            " " + _vm._s(_vm.roomUser.nickname || _vm.roomUser.username) + " "
          ),
        ]),
        _c("span", [_vm._v(_vm._s(_vm.$t("call.screenShare.sharing")))]),
      ]),
      _vm.hasEmceeRole() || _vm.isScreenShareUser
        ? _c(
            "div",
            {
              staticClass: "btn-quitShare",
              on: { click: _vm.onClickEndScreenShare },
            },
            [_vm._v(_vm._s(_vm.$t("call.screenShare.quit.title")))]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }